/* ============================================================================
   LAH — AVISO "ADICIONADO AOS FAVORITOS"
   Tema: Outubro (Claude 11.0)

   Ao favoritar — no card do catalogo ou na pagina do produto — um cartao
   leve aparece, fica cerca de 3 segundos e sai sozinho:

     [foto]  ✓ Adicionado aos favoritos
             Nome do produto
             Cor

   Entra e sai deslizando e esmaecendo, sem bloquear nada. Tocar no aviso
   abre a lista de favoritos. Um favorito novo substitui o aviso anterior.

   SO AO ADICIONAR. Remover nao gera aviso.

   ============================================================================
   COMO SABE QUE FOI ADICIONADO — e por que ouve na JANELA
   ============================================================================
   O aviso compara o coracao ANTES e DEPOIS do clique: so aparece se ele
   passou de vazio para preenchido (is-favorited).

   A primeira versao ouvia o clique no documento. O lah-wishlist.js tambem
   ouve ali, e registrado antes — entao tratava o clique PRIMEIRO. Quando o
   aviso lia o "antes", o coracao ja estava preenchido, e nenhum aviso saia.

   Agora o aviso ouve na JANELA, em fase de captura. A janela recebe o clique
   antes do documento, sempre — o "antes" e lido antes de qualquer outro
   script mexer no coracao, independente da ordem de carregamento. O "depois"
   e conferido um instante mais tarde, com o lah-wishlist.js ja concluido.

   POSICAO: centralizado na base no celular; canto inferior direito no
   desktop. Com a barra de compra visivel no celular, o aviso sobe acima dela.

   Quem pediu menos movimento no aparelho recebe o aviso so com esmaecimento.
   ============================================================================ */

(function () {
    'use strict';

    if (window.__lahWlAviso) return;
    window.__lahWlAviso = true;

    var DURACAO = 3000;
    var atual = null;
    var timer = null;

    var estilo = document.createElement('style');
    estilo.textContent =
        '.lah-wl-toast{position:fixed;left:50%;bottom:calc(20px + env(safe-area-inset-bottom,0px));z-index:2147483000;' +
        'display:flex;align-items:center;gap:12px;width:max-content;max-width:min(92vw,360px);box-sizing:border-box;' +
        'padding:10px 16px 10px 10px;background:#fff;border:1px solid #ECECEB;border-radius:14px;' +
        'box-shadow:0 10px 30px rgba(0,0,0,.12),0 2px 6px rgba(0,0,0,.06);' +
        'font-family:Helvetica,"Helvetica Neue",Arial,sans-serif;color:#111;cursor:pointer;' +
        'opacity:0;transform:translate(-50%,10px);transition:opacity .25s ease,transform .25s ease;}' +
        '.lah-wl-toast.is-on{opacity:1;transform:translate(-50%,0);}' +
        '.lah-wl-toast__foto{flex-shrink:0;width:52px;height:52px;border-radius:10px;object-fit:cover;background:#F5F5F4;}' +
        '.lah-wl-toast__texto{display:flex;flex-direction:column;gap:1px;min-width:0;}' +
        '.lah-wl-toast__rotulo{font-size:12px;font-weight:500;color:#1E7A4C;}' +
        '.lah-wl-toast__nome{font-size:14px;font-weight:600;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}' +
        '.lah-wl-toast__cor{font-size:12.5px;color:#8A8A8A;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}' +
        '@media (min-width:1000px){.lah-wl-toast{left:auto;right:24px;bottom:24px;transform:translateY(10px);}' +
        '.lah-wl-toast.is-on{transform:translateY(0);}}' +
        '@media (prefers-reduced-motion:reduce){.lah-wl-toast,.lah-wl-toast.is-on{transition:opacity .2s ease;transform:translate(-50%,0);}}' +
        '@media (prefers-reduced-motion:reduce) and (min-width:1000px){.lah-wl-toast,.lah-wl-toast.is-on{transform:none;}}';
    document.head.appendChild(estilo);

    function escapeHtml(str) {
        var div = document.createElement('div');
        div.textContent = str == null ? '' : String(str);
        return div.innerHTML;
    }

    function ajustarAltura(el) {
        if (window.innerWidth >= 1000) return;
        var barra = document.querySelector('.lah-purchase-dock.is-visible');
        if (!barra) return;
        var altura = barra.getBoundingClientRect().height || 0;
        el.style.bottom = 'calc(' + (altura + 16) + 'px + env(safe-area-inset-bottom, 0px))';
    }

    function fechar(el) {
        if (!el) return;
        el.classList.remove('is-on');
        setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 300);
    }

    function mostrar(dados) {
        if (atual) fechar(atual);
        clearTimeout(timer);

        var el = document.createElement('div');
        el.className = 'lah-wl-toast';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        el.innerHTML =
            (dados.imagem ? '<img class="lah-wl-toast__foto" src="' + escapeHtml(dados.imagem) + '" alt="">' : '') +
            '<span class="lah-wl-toast__texto">' +
            '<span class="lah-wl-toast__rotulo">✓ Adicionado aos favoritos</span>' +
            '<span class="lah-wl-toast__nome">' + escapeHtml(dados.nome) + '</span>' +
            (dados.cor ? '<span class="lah-wl-toast__cor">' + escapeHtml(dados.cor) + '</span>' : '') +
            '</span>';

        el.addEventListener('click', function () {
            fechar(el);
            var abrir = document.querySelector('.lah-wishlist-toggle');
            if (abrir) abrir.click();
        });

        document.body.appendChild(el);
        ajustarAltura(el);
        requestAnimationFrame(function () {
            requestAnimationFrame(function () { el.classList.add('is-on'); });
        });

        atual = el;
        timer = setTimeout(function () {
            fechar(el);
            if (atual === el) atual = null;
        }, DURACAO);
    }

    function dadosDoCard(btn) {
        var card = btn.closest('product-item');
        var radio = card && card.querySelector('.color-swatch__radio:checked');
        var foto = card && card.querySelector('.product-item__primary-image:not([hidden])');

        var imagem = '';
        if (foto) imagem = foto.currentSrc || foto.src || '';
        if (!imagem) imagem = btn.getAttribute('data-image') || '';
        if (imagem.indexOf('//') === 0) imagem = 'https:' + imagem;

        return {
            nome: btn.getAttribute('data-title') || '',
            cor: radio ? radio.value : '',
            imagem: imagem
        };
    }

    function dadosDaPagina() {
        var auglio = document.querySelector('.auglio-tryon-btn-product-page');
        var vid = auglio ? auglio.getAttribute('data-item_id') : null;
        var mapa = {};
        try { mapa = JSON.parse((document.getElementById('lah-wishlist-variant-map') || {}).textContent || '{}'); } catch (e) {}
        var v = vid ? mapa[vid] : null;
        if (!v) return null;

        var imagem = v.image || '';
        if (imagem.indexOf('//') === 0) imagem = 'https:' + imagem;

        return { nome: v.title || '', cor: v.color || '', imagem: imagem };
    }

    /* Janela, fase de captura — ver COMO SABE QUE FOI ADICIONADO no topo. */
    window.addEventListener('click', function (event) {
        var t = event.target;
        if (!t || !t.closest) return;

        var card = t.closest('[data-lah-wl-card]');
        var pdp = card ? null : t.closest('.lah-heart-btn');
        if (!card && !pdp) return;

        var alvo = card || pdp;
        var antes = alvo.classList.contains('is-favorited');
        if (antes) return;

        setTimeout(function () {
            if (!alvo.classList.contains('is-favorited')) return;
            var dados = card ? dadosDoCard(card) : dadosDaPagina();
            if (dados && dados.nome) mostrar(dados);
        }, 60);
    }, true);
})();
